import PlainItemsSelectorBox from 'app/common/ui-next/_filter-compilations/plain-items-selector-box'
import { defaultOrgsDataReceiver, defaultOrgsSelection, orgTypesFilterSelection, orgsFilter, orgsFilterSelection } from 'app/dataProviders/filter-items'
import { OrgType } from 'app/dataTypes/org'
import { useCallback, useEffect } from 'react'
import { subscibeTo } from 'app/common/data-box-store'


type Props = {
  id: string
  pending: boolean
}

export const OrgsFilter = ({ id, pending }: Props) => {
  const orgTypesFilterHandler = useCallback((data: OrgType[]) => {
    if (data.length === 1) {
      orgsFilter.addDataReceiver(
        defaultOrgsDataReceiver,
      )
      orgsFilter.dataReceive()
      return
    }
    orgsFilter.resetToDefault()
  }, [])

  useEffect(() => {
    const unsubsribeOrgType = subscibeTo<OrgType[]>(orgTypesFilterSelection.id, orgTypesFilterHandler)
    return (() => {
      unsubsribeOrgType()
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <PlainItemsSelectorBox
      id={id}
      label="Заведение"
      header="Выбор заведения"
      dataBoxData={orgsFilter}
      dataBoxSelection={orgsFilterSelection}
      pleaseSelectText="Нет данных"
      selectedAllOnEmptySelection
      disabled={pending}
      multiple
      defaultSelection={defaultOrgsSelection}
    />
  )
}
